<template>
  <div class="actions-collapsed-list">
    <button
      class="btn btn-function exit-collapsed-list"
      @click="activateRouteActions"
    >
      <i
        v-tooltip.right="'Cancel'"
        class="glyphicon glyphicon-chevron-left"
        aria-hidden="true"
      />
    </button>

    <div class="action-icon">
      <button
        v-tooltip.right="$t('CAMPAIGN_STEP_ROUTING_SELECTED_EDIT')"
        class="btn btn-list-function"
        @click="editCallRoute"
      >
        <i class="typcn typcn-edit" />
        <span
          v-t="'CAMPAIGN_STEP_ROUTING_SELECTED_EDIT'"
          class="hint-text-mobile"
        />
      </button>
    </div>

    <div class="action-icon">
      <button
        v-tooltip.right="$t('CAMPAIGN_STEP_ROUTING_SELECTED_DELETE')"
        class="btn btn-list-function"
        @click="deleteRoute"
      >
        <i class="typcn typcn-trash" />
        <span
          v-t="'CAMPAIGN_STEP_ROUTING_SELECTED_DELETE'"
          class="hint-text-mobile"
        />
      </button>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import sharedMessages from '@/core/locales';
import messages from '../locales';

export default defineComponent({
  name: 'RoutingTargetActions',
  props: {
    callRoute: {
      type: Object,
      required: true,
    }
  },
  methods: {
    activateRouteActions() {
      this.$emit('activate-route-actions', this.callRoute.id);
    },
    editCallRoute() {
      this.$emit('edit-call-route', this.callRoute);
    },
    deleteRoute() {
      this.$emit('delete-route', this.callRoute.id);
    },
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en',
  },
});
</script>
